import type { Client, ClientStatus } from '@frontend/api-types';
import { identifyGrowthBook } from '@frontend/react/growthbook';
import { identifyCio } from './cio';
import { identifySegment } from './segment';
import { identifySentry } from './sentry';

export const identifyClient = async (
  client: Client,
  env: EnvType,
  clientStatus?: ClientStatus,
  urlAttribution?: { fbclid?: string; gclid?: string },
) => {
  if (!client) return;

  identifySegment({
    client,
    clientStatus,
    env,
    fbclid: urlAttribution?.fbclid,
    gclid: urlAttribution?.gclid,
  });
  identifyCio({ client, env });
  identifySentry({ email: client.email, env, id: client.id });
  await identifyGrowthBook({ clientId: client.id });
};
